export const DEFAULT_FORM_VALUES = {
  storeOperationManager: '',
  storeSecurityOfficer: '',
  konbiniEmail: '',
  konbiniPhoneNumber: '',
  secondhandDealerNumber: '',
}
